import * as dialogConstants from '../constants/dialogConstants';
//import LearnerActionReview from '../components/objects/learnerAction/LearnerActionReview'; //eslint-disable-line import/no-named-as-default
import MultipleChoiceReview from '../components/objects/multipleChoice/singleAnswer/SingleAnswerReview'; //eslint-disable-line import/no-named-as-default
import MultipleAnswerReview from '../components/objects/multipleChoice/multipleAnswer/MultipleAnswerReview'; //eslint-disable-line import/no-named-as-default
import ConversationSingleAnswerReview from '../components/objects/multipleChoice/conversationSingleAnswer/ConversationSingleAnswerReview'; //eslint-disable-line import/no-named-as-default
import ShortAnswerReview from '../components/objects/shortResponse/ShortResponseReview'; //eslint-disable-line import/no-named-as-default

import KpiDashboard from '../components/objects/kpi/KpiDashboard';//eslint-disable-line import/no-named-as-default
import BadgeDashboard from '../components/objects/badges/BadgeDashboard';//eslint-disable-line import/no-named-as-default
import ActorPrompt from '../components/initialisation/ActorPrompt';//eslint-disable-line import/no-named-as-default
import ExitPrompt from '../components/initialisation/ExitPrompt';//eslint-disable-line import/no-named-as-default
import ResumePrompt from '../components/initialisation/ResumePrompt';//eslint-disable-line import/no-named-as-default
import LocalePrompt from '../components/initialisation/LocalePrompt';//eslint-disable-line import/no-named-as-default
//import Hello from '../components/Hello'; //eslint-disable-line import/no-named-as-default
let DIALOG_STATE_CLASSES = {
    isOpen: dialogConstants.DIALOG_CLASS_STATE_OPEN,
    isClosed: dialogConstants.DIALOG_CLASS_STATE_CLOSED
};

let OPEN_STATE ={
    opacity: 1

};

let CLOSED_STATE ={
    opacity: 0
};

//DEFAULT

let DIALOG_CHILD_COMPONENTS = {
    childComponent: null,
    id:'pageNotFound',
    componentProps: null
};

export let DIALOG_CONFIG = {
    dialogComponent: dialogConstants.CONTENT_DIALOG,
    title: "",
    icon: "",
    theme: "",
    showCloseBtn: true,
    onClose: undefined,
    childComponents: [DIALOG_CHILD_COMPONENTS]
};


//LEANER_ACTION_REVIEW
let LEANER_ACTION_REVIEW_CHILD_COMPONENTS = {
    childComponent: ConversationSingleAnswerReview,
    id:'learnerActionReview',
    componentProps:{}
};

export let LEANER_ACTION_REVIEW_CONFIG = {
    dialogComponent: dialogConstants.CONTENT_DIALOG,
    title: "Review",
    icon: "icons8-right",
    theme: "",
    showCloseBtn: true,
    onClose: undefined,
    childComponents: [LEANER_ACTION_REVIEW_CHILD_COMPONENTS]
};



//LEANER_ACTION_REVIEW

let MULTIPLE_CHOICE_REVIEW_CHILD_COMPONENTS = {
    childComponent: MultipleChoiceReview,
    id:'multipleChoicenReview',
    componentProps:{}
};

export let MULTIPLE_CHOICE_REVIEW_CONFIG = {
    dialogComponent: dialogConstants.CONTENT_DIALOG,
    title: "Review",
    icon: "icons8-right",
    theme: "",
    showCloseBtn: true,
    onClose: undefined,
    childComponents: [MULTIPLE_CHOICE_REVIEW_CHILD_COMPONENTS]
};

//MULTIPLE_ANSWER_REVIEW
let MULTIPLE_ANSWER_REVIEW_CHILD_COMPONENTS = {
    childComponent: MultipleAnswerReview,
    id:'multipleAnswerReview',
    componentProps:{}
};

export let MULTIPLE_ANSWER_REVIEW_CONFIG = {
    dialogComponent: dialogConstants.CONTENT_DIALOG,
    title: "Review",
    icon: "icons8-right",
    theme: "",
    showCloseBtn: true,
    onClose: undefined,
    childComponents: [MULTIPLE_ANSWER_REVIEW_CHILD_COMPONENTS]
};


let SHORT_ANSWER_REVIEW_CHILD_COMPONENTS = {
    childComponent: ShortAnswerReview,
    id:'shortAnswerReview',
    componentProps:{}
};

export let SHORT_ANSWER_REVIEW_CONFIG = {
    dialogComponent: dialogConstants.CONTENT_DIALOG,
    title: "Review",
    icon: "icons8-right",
    theme: "",
    showCloseBtn: true,
    onClose: undefined,
    childComponents: [SHORT_ANSWER_REVIEW_CHILD_COMPONENTS]
};


let ASSET_CHILD_COMPONENTS = {
    childComponent: undefined,
    id:'assetDialog',
    componentProps:{}
};

export let ASSET_CONFIG = {
    dialogComponent: undefined,
    title: "",
    icon: "",
    theme: "",
    showCloseBtn: true,
    onClose: undefined,
    childComponents: [ASSET_CHILD_COMPONENTS]
};


export let SCREEN_CONFIG = {
    component: undefined,
    biteCallbacks: {},
    parentScreen: undefined,
    screen: undefined,
    showCloseBtn: true,
    onClose: undefined,
    sourceId: undefined
};


let PERFORMANCE_KPI_CHILD_COMPONENTS = {
    childComponent: KpiDashboard,
    id:'KpiDashboard',
    componentProps:{}
};


let PERFORMANCE_BADGE_CHILD_COMPONENTS = {
    childComponent: BadgeDashboard,
    id:'BadgeDashboard',
    componentProps:{}
};


export let PERFORMANCE_CONFIG = {
    dialogComponent: dialogConstants.CONTENT_DIALOG,
    title: "Performance & Badges",
    icon: "icons8-right",
    theme: "performance",
    showCloseBtn: true,
    onClose: undefined,
    sourceId:undefined,
    childComponents: [PERFORMANCE_KPI_CHILD_COMPONENTS,PERFORMANCE_BADGE_CHILD_COMPONENTS]
};

let XAPI_INIT_ACTOR_CHILD_COMPONENTS = {
    childComponent: ActorPrompt,
    id:'InitActor',
    componentProps:{}
};

export let XAPI_INIT_ACTOR_CONFIG = {
    dialogComponent: dialogConstants.INIT_DIALOG,
    title: "",
    icon: "",
    theme: "init-prompt",
    showCloseBtn: true,
    onClose: undefined,
    childComponents: [XAPI_INIT_ACTOR_CHILD_COMPONENTS]
};

let EXIT_CHILD_COMPONENTS = {
    childComponent: ExitPrompt,
    id:'ExitPrompt',
    componentProps:{}
};

export let EXIT_CONFIG = {
    dialogComponent: dialogConstants.INIT_DIALOG,
    title: "Goodbye",
    icon: "",
    theme: "init-prompt",
    showCloseBtn: true,
    onClose: undefined,
    sourceId:"exitBtn",
    childComponents: [EXIT_CHILD_COMPONENTS]
};


let RESUME_CHILD_COMPONENTS = {
    childComponent: ResumePrompt,
    id:'ResumePrompt',
    componentProps:{}
};

export let RESUME_CONFIG = {
    dialogComponent: dialogConstants.INIT_DIALOG,
    title: "Welcome Back",
    icon: "",
    theme: "init-prompt",
    showCloseBtn: true,
    onClose: undefined,
    childComponents: [RESUME_CHILD_COMPONENTS]
};



let LOCALE_CHILD_COMPONENTS = {
    childComponent: LocalePrompt,
    id:'InitLocale',
    componentProps:{}
};

export let LOCALE_CONFIG = {
    dialogComponent: dialogConstants.INIT_DIALOG,
    title: "",
    icon: "",
    theme: "init-prompt",
    showCloseBtn: true,
    onClose: undefined,
    childComponents: [LOCALE_CHILD_COMPONENTS]
};
/*
//LEANER_ACTION_REVIEW
export let CLICK_REVEAL_CHILD_COMPONENT = {
    childComponent: undefined,
    id:'',
    componentProps:{}
};

export let CLICK_REVEAL_CONFIG = {
    dialogComponent: dialogConstants.CLICK_REVEAL_DIALOG,
    title: "",
    icon: "",
    theme: "",
    showCloseBtn: true,
    callbacks: {},
    childComponents: []
};


*/
//DEFAULT PARENT MODELS
export let DIALOG = {
    component:dialogConstants.DIALOG_POPUP,
    dialogTypeConstant: dialogConstants.DIALOG,
    className: dialogConstants.DIALOG_CLASSNAME,
    isOpen: false,
    currentClassState: DIALOG_STATE_CLASSES.isClosed,
    classStates: DIALOG_STATE_CLASSES,
    currentState: CLOSED_STATE,
    openState: OPEN_STATE,
    closedState: CLOSED_STATE,
    config: DIALOG_CONFIG,
    render: true
};

//DEFAULT PARENT MODELS
export let SIDE_DIALOG = {
    component:dialogConstants.DIALOG_POPUP,
    dialogTypeConstant: dialogConstants.DIALOG,
    className: dialogConstants.SIDE_DIALOG_CLASSNAME,
    isOpen: false,
    currentClassState: DIALOG_STATE_CLASSES.isClosed,
    classStates: DIALOG_STATE_CLASSES,
    currentState: CLOSED_STATE,
    openState: OPEN_STATE,
    closedState: CLOSED_STATE,
    config: DIALOG_CONFIG,
    render: true
};

export let ASSET_DIALOG ={
    component:dialogConstants.ASSET_DIALOG,
    dialogTypeConstant: dialogConstants.DIALOG,
    className: dialogConstants.ASSET_DIALOG_CLASSNAME,
    isOpen: false,
    currentClassState: DIALOG_STATE_CLASSES.isClosed,
    classStates: DIALOG_STATE_CLASSES,
    currentState: CLOSED_STATE,
    openState: OPEN_STATE,
    closedState: CLOSED_STATE,
    config: DIALOG_CONFIG,
    render: true
};

export let SCREEN_DIALOG ={
    component:dialogConstants.SCREEN_DIALOG,
    dialogTypeConstant: dialogConstants.DIALOG,
    className: dialogConstants.SCREEN_DIALOG_CLASSNAME,
    isOpen: false,
    currentClassState: DIALOG_STATE_CLASSES.isClosed,
    classStates: DIALOG_STATE_CLASSES,
    currentState: CLOSED_STATE,
    openState: OPEN_STATE,
    closedState: CLOSED_STATE,
    config: SCREEN_CONFIG,
    render: true
};


//DEFAULT PARENT MODELS
/*
export let CLICK_REVEAL_DIALOG = {
    component:dialogConstants.CLICK_REVEAL_DIALOG_POPUP,
    dialogTypeConstant: dialogConstants.CLICK_REVEAL_DIALOG,
    className: dialogConstants.CLICK_REVEAL_DIALOG_CLASSNAME,
    isOpen: false,
    currentClassState: DIALOG_STATE_CLASSES.isClosed,
    classStates: DIALOG_STATE_CLASSES,
    currentState: CLOSED_STATE,
    openState: OPEN_STATE,
    closedState: CLOSED_STATE,
    config: CLICK_REVEAL_CONFIG,
    render: true
};
*/

export let DIALOG_TYPES = [DIALOG,SIDE_DIALOG,ASSET_DIALOG];



/** WEBPACK FOOTER **
 ** ./src/models/dialogModels.js
 **/